/*************************************************************************
Alexander Self
10/24/2017
Navbar
*************************************************************************/
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setMapView, setMapLocation } from '../actions/map_actions';

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.renderLinks = this.renderLinks.bind(this);
    this.renderNavLinks = this.renderNavLinks.bind(this);
  }
  renderLinks() {
      if (this.props.authenticated) {
        return [
          <li key={'9F'}>
            { this.props.mapView ? <div>
              <button id="kau" className="btn-flat" onClick={(e) => this.props.setMapLocation(e.target.id)}>Ka'u</button>
              <button id="keaau" className="btn-flat" onClick={(e) => this.props.setMapLocation(e.target.id)}>Kea'au</button>
            </div> : ''
          }
          </li>,
          <li key={'8F'} className="map-check">
            { this.props.mapView ? <a className="waves-effect waves-light btn blue" onClick={this.props.setMapView}>App View</a>
              : <a className="waves-effect waves-light btn blue" onClick={this.props.setMapView}>Map View</a>
            }
          </li>,
          <li key={'6F'}>{this.props.email}</li>,
          <li key={'7F'}><Link className="nav-link" to="/signout">Sign Out</Link></li>
        ];
      } else {
        return <li><Link className="nav-link" to="/">Sign In</Link></li>;
      }
  }
  /* Only want these showing up on hamburger menu */
  renderNavLinks() {
    if (this.props.authenticated) {
      return [
        <li key={'1F'}><Link className="nav-link" to="/dashboard">Dashboard</Link></li>,
        <li key={'2F'}><Link className="nav-link" to="/timesheet">Timesheet</Link></li>,
        <li key={'3F'}><Link className="nav-link" to="/schedule">Schedule</Link></li>,
        <li key={'4F'}><Link className="nav-link" to="/faultlog">Fault Log</Link></li>,
        <li key={'5F'}><Link className="nav-link" to="/profile">Profile</Link></li>
      ];
    } else {
      return <li></li>;
    }
  }
  render() {
    return (
      <nav id="main-nav">
        <div className="nav-wrapper">
          <Link to="/" className="brand-logo left himn-logo">Hawaiian Macadamia Nut Services</Link>
          <Link data-activates="slide-out" className="nav-link button-collapse right" to="/signout">Sign Out</Link>
          <ul className="right hide-on-med-and-down">
            { this.renderLinks() }
          </ul>
        </div>
      </nav>
    );
  }
};

function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated,
    user: state.auth.user,
    email: state.auth.user.email,
    field: state.misc.field,
    mapView: state.misc.mapView
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setMapView,
    setMapLocation
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);



// WEBPACK FOOTER //
// ./src/containers/navbar.js